import React, { useEffect, useState, useContext, useCallback } from "react";
import * as S from "./ConsultoresStyle";
import ModalCriar from "./ModalCriar/ModalCriar";
import ModalConsultor from "./ModalConsultor/ModalConsultor";
import Loading from "../Loader";
import { formatDateClients } from "../ASSETS/assets";
import { AuthContext } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaSearch, FaEdit, FaUserShield } from "react-icons/fa"; // Ícone adicionado
import { consultorService } from "../../Services/consultorService";
import debounce from "lodash.debounce";
import axios from "axios"; // Importar o axios

export default function Consultores() {
  const { authState } = useContext(AuthContext);
  const [modalCriarOpen, setModalCriarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [consultores, setConsultores] = useState([]);
  const [load, setLoad] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isLoggingIn, setIsLoggingIn] = useState(false); // Estado para o loading do botão admin
  const navigate = useNavigate();

  // Função para buscar os consultores no backend
  const fetchConsultores = async (name = "", cpfCnpj = "") => {
    setLoad(true);
    try {
      const data = await consultorService.searchConsultores(name, cpfCnpj);
      setConsultores(data);
    } catch (err) {
      console.error("Erro ao buscar consultores:", err);
      setConsultores([]); // Limpa a lista em caso de erro
    } finally {
      setLoad(false);
    }
  };

  // Função para lidar com o login do admin e abrir a nova aba
  const handleAdminLogin = async () => {
    setIsLoggingIn(true);
    try {
      const email = process.env.REACT_APP_APP_LOGIN_EMAIL_CONSULTORES;
      const password = process.env.REACT_APP_APP_LOGIN_SENHA_CONSULTORES;

      if (!email || !password) {
        console.error(
          "Variáveis de ambiente para login de admin não configuradas."
        );
        alert("Erro de configuração: Credenciais de admin não encontradas.");
        return;
      }

      const response = await axios.post(
        "https://consultoresbackend.goldenbrasil.com.br/api/auth/admin/login",
        { email, password }
      );

      const { accessToken, refreshToken } = response.data;

      if (accessToken && refreshToken) {
        const url = `https://consultor.goldenbrasil.com.br/admin/login?accessToken=${accessToken}&refreshToken=${refreshToken}`;
        window.open(url, "_blank", "noopener,noreferrer");
      } else {
        throw new Error("Tokens não recebidos na resposta da API.");
      }
    } catch (error) {
      console.error("Falha ao acessar a plataforma de admin:", error);
      alert(
        "Não foi possível acessar a plataforma de admin. Verifique as credenciais ou a conexão."
      );
    } finally {
      setIsLoggingIn(false);
    }
  };

  // Cria uma versão "debounced" da função de busca
  const debouncedFetch = useCallback(debounce(fetchConsultores, 500), []);

  useEffect(() => {
    if (
      authState.permission &&
      authState.permission !== "ALL" &&
      !authState.permission.includes("GERENCIAR CONSULTORES")
    ) {
      navigate("/");
    }
    // Busca inicial sem filtros
    fetchConsultores();
  }, [authState.permission, navigate]);

  // Efeito para buscar no backend quando o termo de busca muda
  useEffect(() => {
    const isNumeric = /^\d+$/.test(searchTerm.replace(/[^\d]/g, ""));
    const name = !isNumeric ? searchTerm : "";
    const cpfCnpj = isNumeric ? searchTerm : "";
    debouncedFetch(name, cpfCnpj);
  }, [searchTerm, debouncedFetch]);

  return (
    <>
      <Loading load={load} />
      {modalCriarOpen && (
        <ModalCriar
          onClose={() => {
            fetchConsultores(); // Recarrega a lista após criar
            setModalCriarOpen(false);
          }}
        />
      )}
      {selected && (
        <ModalConsultor
          consultor={selected}
          onClose={() => {
            fetchConsultores(); // Recarrega a lista após editar
            setSelected(null);
          }}
        />
      )}
      <S.ConsultoresContainer>
        <S.ContentBox>
          <S.Header>
            {/* NOVO BOTÃO DE ACESSO ADMIN */}
            <S.AdminLoginButton
              onClick={handleAdminLogin}
              disabled={isLoggingIn}
            >
              <FaUserShield />{" "}
              {isLoggingIn ? "Acessando..." : "Plataforma Admin"}
            </S.AdminLoginButton>

            {/* Conteúdo original do header agrupado para alinhamento correto */}
            <S.HeaderRightContainer>
              <S.Title>Gerenciar Consultores</S.Title>
              <S.ActionButton onClick={() => setModalCriarOpen(true)}>
                <FaPlus /> Cadastrar Consultor
              </S.ActionButton>
            </S.HeaderRightContainer>
          </S.Header>

          <S.FilterArea>
            <S.SearchBar>
              <input
                type="text"
                placeholder="Pesquisar por Nome ou CPF/CNPJ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button>
                <FaSearch />
              </button>
            </S.SearchBar>
          </S.FilterArea>

          <S.TableContainer>
            <S.Table>
              <S.TableHeader>
                <S.TableRow>
                  <S.TableHeaderCell>ID</S.TableHeaderCell>
                  <S.TableHeaderCell>Nome</S.TableHeaderCell>
                  <S.TableHeaderCell>CPF/CNPJ</S.TableHeaderCell>
                  <S.TableHeaderCell>Data Cad.</S.TableHeaderCell>
                  <S.TableHeaderCell>E-mail</S.TableHeaderCell>
                  <S.TableHeaderCell>Ações</S.TableHeaderCell>
                </S.TableRow>
              </S.TableHeader>
              <S.TableBody>
                {load && consultores.length === 0 ? (
                  <S.TableRow>
                    <S.TableCell colSpan="6">Carregando...</S.TableCell>
                  </S.TableRow>
                ) : consultores.length > 0 ? (
                  consultores.map((consultor) => (
                    <S.TableRow
                      onClick={() => setSelected(consultor)}
                      key={consultor.id}
                    >
                      <S.TableCell>{consultor.id}</S.TableCell>
                      <S.TableCell>{consultor.name}</S.TableCell>
                      <S.TableCell>{consultor.cpfCnpj}</S.TableCell>
                      <S.TableCell>
                        {formatDateClients(consultor.dateCreated)}
                      </S.TableCell>
                      <S.TableCell>{consultor.email}</S.TableCell>
                      <S.TableCell>
                        <S.ActionButton
                          style={{
                            background: "transparent",
                            color: "#E6AA3A",
                            padding: "8px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation(); // Evita que o clique abra o modal de detalhes
                            setSelected(consultor);
                          }}
                        >
                          <FaEdit />
                        </S.ActionButton>
                      </S.TableCell>
                    </S.TableRow>
                  ))
                ) : (
                  <S.TableRow>
                    <S.TableCell colSpan="6">
                      Nenhum consultor encontrado.
                    </S.TableCell>
                  </S.TableRow>
                )}
              </S.TableBody>
            </S.Table>
          </S.TableContainer>
        </S.ContentBox>
      </S.ConsultoresContainer>
    </>
  );
}
